import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatLegacyFormFieldAppearance as MatFormFieldAppearance } from '@angular/material/legacy-form-field';
import { AbstractComponent } from '@shared/common/abstract.component';

@Component({
    selector: 'app-input-password-confirmation',
    styleUrls: ['./password-confirmation-input.component.scss'],
    template: `
        <div class="form-row">
            <app-input-password
                label="Password"
                class="flex-50"
                [(ngModel)]="_value.password"
                (ngModelChange)="_onChange()"
                [appearance]="appearance"
                [minlength]="minlength"
                [maxlength]="maxlength"
                [disabled]="disabled"
                data-testid="input:password"
                [required]="true" />

            <app-input-password
                label="Confirm password"
                class="flex-50"
                [(ngModel)]="_value.confirmation"
                (ngModelChange)="_onChange()"
                [appearance]="appearance"
                [minlength]="minlength"
                [maxlength]="maxlength"
                [disabled]="disabled"
                data-testid="input:confirm-password"
                [required]="true" />
        </div>

        <mat-error *ngIf="errorMessage">
            {{ errorMessage }}
        </mat-error>
    `,
})
export class PasswordConfirmationInputComponent extends AbstractComponent {
    @Output() passwordChange = new EventEmitter<string>();
    @Output() passwordConfirmationChange = new EventEmitter<string>();

    @Input() set password(value: string) {
        this._value.password = value;
    }

    @Input() set passwordConfirmation(value: string) {
        this._value.confirmation = value;
    }

    _value = {
        password: null,
        confirmation: null
    };

    @Input() appearance: MatFormFieldAppearance = 'outline';
    @Input() minlength: number;
    @Input() maxlength: number;
    @Input() disabled = false;

    errorMessage: string;

    _onChange() {
        this.passwordChange.emit(this._value.password);
        this.passwordConfirmationChange.emit(this._value.confirmation);

        if (this._value.password === this._value.confirmation) {
            this.errorMessage = null;
        } else if (this._value.password?.length || this._value.confirmation?.length) {
                this.errorMessage = 'Passwords do not match';
            }
    }
}
